"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EncryptionService = void 0;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class EncryptionService {
  constructor(aesFactories, factories) {
    _defineProperty(this, "_aesServices", void 0);

    _defineProperty(this, "_encryptionFactories", void 0);

    this._aesServices = aesFactories;
    this._encryptionFactories = factories;
  }

  async encrypt(plainText, key) {
    const encryptionFactory = this._encryptionFactories.find(factory => factory.algorithm === key.algorithm && factory.provider === key.provider);

    if (!encryptionFactory) {
      throw new Error('Encryption factory not found.');
    }

    const aesService = this._aesServices.find(service => service.provider === encryptionFactory.aesProvider);

    if (!aesService) {
      throw new Error('AES encryption service not found.');
    }

    const aesKey = await aesService.createKey();
    const encryptedContent = await aesService.encrypt(aesKey, plainText);
    const cekPlainText = aesService.aesToKeyId(aesKey);
    const encryptedCek = await encryptionFactory.encrypt(key.providerKeyId, cekPlainText).catch(() => {
      throw new Error('Error when encrypting with factory.');
    });
    return {
      cipherText: encryptedContent,
      cek: {
        key: encryptedCek,
        alg: 'AES'
      },
      kek: {
        key: key.keyId,
        alg: key.algorithm,
        prov: key.provider
      }
    };
  }

  async decrypt(data, key) {
    const encryptionFactory = this._encryptionFactories.find(factory => factory.algorithm === key.algorithm && factory.provider === key.provider);

    if (!encryptionFactory) {
      throw new Error('Encryption factory not found.');
    }

    const aesService = this._aesServices.find(service => service.provider === encryptionFactory.aesProvider);

    if (!aesService) {
      throw new Error('AES encryption service not found.');
    }

    const cekPlainText = await encryptionFactory.decrypt(key.providerKeyId, data.cek.key).catch(() => {
      throw new Error('Error when decrypting with factory.');
    });
    const aesKey = aesService.keyIdToAes(cekPlainText);
    return aesService.decrypt(aesKey, data.cipherText);
  }

}

exports.EncryptionService = EncryptionService;